// Content-Disposition 헤더에서 파일명을 추출해 Blob을 브라우저 다운로드로 트리거
// NestJS(RFC 5987 filename*=UTF-8''...)와 FastAPI(filename="...") 형식 모두 지원
// explicitFileName이 주어지면 헤더 파싱 없이 그대로 사용 (스토리지 응답에 원본 파일명이 없는 경우 호출부에서 지정)
export const downloadFile = (blob: Blob, contentDisposition?: string, explicitFileName?: string) => {
	let fileName = explicitFileName ?? 'download.xlsx';

	if (!explicitFileName && contentDisposition) {
		// RFC 5987 형식 파싱 (filename*=UTF-8''encoded-name)
		const rfc5987Match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/i);
		if (rfc5987Match && rfc5987Match[1]) {
			fileName = decodeURIComponent(rfc5987Match[1]);
		} else {
			// 일반 형식 파싱 (filename="name" 또는 filename=name)
			const standardMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
			if (standardMatch && standardMatch[1]) {
				fileName = standardMatch[1].replace(/['"]/g, '');
				fileName = decodeURIComponent(fileName);
			}
		}
	}

	// Blob URL 생성 및 다운로드
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};
